import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { ForcedLabels } from '@agion/ui'

/**
 * The texts of a step the runner forced to finish (agion/Agion#2460) in the
 * Activity sidebar: the status label and one warning per forced reason, each
 * saying what to do. The design system picks the warning from the reason
 * (forcedEndingNote), and ignores a reason it does not know.
 */
export function useForcedEndingLabels(): ForcedLabels {
  const { t } = useTranslation(['chat'])
  return useMemo<ForcedLabels>(
    () => ({
      forced: t('chat:executionLog.forced.label', 'Finished early'),
      forcedBudget: t(
        'chat:executionLog.forced.budget',
        'Finished early: ran out of turns. The result may be incomplete. Narrow what the step asks for, or split it.',
      ),
      forcedStuckRepeating: t(
        'chat:executionLog.forced.stuckRepeating',
        "Finished early: kept repeating the same call. The result may be incomplete. Change the step's instructions.",
      ),
      forcedRepeatedFailure: t(
        'chat:executionLog.forced.repeatedFailure',
        'Finished early after repeated tool errors. The result may be incomplete. Check the connection the step uses.',
      ),
      forcedSchemaChurn: t(
        'chat:executionLog.forced.schemaChurn',
        'Finished early: the source data kept changing shape. The result may be incomplete. Check the source schema.',
      ),
    }),
    [t],
  )
}
